// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { acala as _acala } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the acala chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 787
 * Chain Name: Acala
 * Default Block Explorer: https://blockscout.acala.network
 * Default RPC URL: https://eth-rpc-acala.aca-api.network
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { acala } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: acala,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const acala = createCommon({
	..._acala,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
